import { Space } from 'component/Space'
import { Vertical } from 'component/Vertical'
import { observer } from 'mobx-react-lite'
import { BuyButton } from 'page/catalog/buttons/BuyButton'
import { TryButtonBaga } from 'page/catalog/buttons/TryButtonBaga'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { ui } from 'store/home/ui/HomeUiStore'
import { Item } from 'type/Item'
import css from './ItemActionsBaga.module.scss'

type Props = {
  item: Item
}

export const ItemActionsBaga = observer(({ item }: Props) => {
  const demo = useDemo()
  const { mobile } = ui.window
  const buy = demo.isBuyButtonVisible(item, false)
  const tryon = demo.canTry(item) || demo.canCombine(item)

  if (!buy && !tryon) return null

  if (mobile) return <Vertical gap={8}>
    {buy && <BuyButton className={css.buy} item={item} />}
    {tryon && <TryButtonBaga item={item} />}
  </Vertical>

  return <Space gap={8} spread>
    {buy && <BuyButton className={css.buy} item={item} />}
    {tryon && <TryButtonBaga item={item} />}
  </Space>
})
